import React, { useState } from "react";
import UploadResumeImg from "../../Assets/Career/uploadResume.png";
import Card from "./Card";
import JobApplicationModal from "./JobApplicationModal";
const jobOpenings = [
  {
    id: 1,
    title: "Structural Engineer",
    Location: "Ho, Bhubaneshwar",
    Department: "Design section",
    Experience: "M.Tech Civil (10+ Years)",
  },
  {
    id: 2,
    title: "Quality control engineer",
    Location: "Ho, Bhubaneswar",
    Department: "Soil section",
    Experience: "M.Tech Civil (10+ Years)",
  },
  {
    id: 3,
    title: "Business development",
    Location: "Ho, Bhubaneswar",
    Department: "Railway",
    Experience: "MBA with 5 year's",
  },
  {
    id: 4,
    title: "Chemist",
    Location: "HO, Bhubaneshwar",
    Department: "Water,chemical",
    Experience: "MSC with 5 year's",
  },
];

const WorkWithUs = () => {
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (job) => {
    setSelectedJob(job);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedJob(null);
    setIsModalOpen(false);
  };

  return (
    <div className="px-8 md:px-16 mt-4 mb-4 md:mt-8 md:mb-8 flex flex-col">
      <h2
        data-aos="fade-up"
        style={{ fontFamily: "Poppins, sans-serif" }}
        className="text-3xl md:text-5xl  tracking-wide font-medium mb-1  text-[#1E1E1E]"
      >
        Work With US
      </h2>
      <p
        data-aos="fade-right"
        style={{ fontFamily: "Poppins, sans-serif" }}
        className="text-md mb-8 text-lg tracking-wider  text-[#0218DC]"
      >
        Current Openings
      </p>
      <div className="flex  md:flex-row flex-col-reverse gap-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {jobOpenings?.map((item) => {
            return (
              <Card key={item.id} item={item} onApply={() => openModal(item)} />
            );
          })}
        </div>
        <div
          data-aos="fade-up"
          className="flex flex-col h-[500px] gap-2 mb-8 drop-shadow-2xl md:pl-7 "
        >
          <img
            className="w-full h-full object-fill rounded-md"
            src={UploadResumeImg}
            alt="uploadImage"
          />
          <button className="py-2 bg-[#0218DC] text-sm font-semibold hover:bg-blue-800 text-white rounded-md w-full">
            Upload Here
          </button>
        </div>
      </div>

      {isModalOpen && (
        <JobApplicationModal job={selectedJob} onClose={closeModal} />
      )}
    </div>
  );
};

export default WorkWithUs;
